export default function randomString(prefix = '', size = 8) {
  for (;;) {
    const random = Math.random()
      .toString(36)
      .slice(-size)
    if (random.length === size) {
      return `${prefix}${random}`
    }
  }
}
